import {useContext} from "react";

import {
    MathEditorContext,
    type MathEditorState,
} from "./math-editor-context.ts";

/**
 * Hook providing access to external state of the MathEditor.
 */
export const useMathEditorContext = (): MathEditorState =>
    useContext(MathEditorContext);
